import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 1.84229L12.0744 4.51067L17.5 2.24999V8.62499L22 6.74999V18.9494L16.5 22.1577L11.9256 19.4893L6.5 21.75V15.375L2 17.25V5.05062L7.5 1.84229ZM17.5 10.7917L17.5 19.259L20 17.8006V9.74999L17.5 10.7917ZM15.5 19.259L15.5 10.6994L13 9.24103V17.8006L15.5 19.259ZM11 17.7083V9.24103L8.5 10.6994V18.75L11 17.7083Z"}}]};

const MapDoubleFilled = Vue.extend<IconProps>({
  name: 'MapDoubleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-double-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapDoubleFilled;
